import React, { forwardRef, ReactElement, Ref } from "react";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";

/**
 * Defines an "up" slide transition.
 */
export const TransitionUp = forwardRef(function Transition(
	props: TransitionProps & { children: ReactElement<unknown> },
	ref: Ref<unknown>
) {
	return <Slide direction="up" ref={ref} {...props} />;
});
